import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import MaterialTable from 'material-table';
import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const ConsolidatedMeasurements = ({
  dataDisponibility,
  dataResponse,
  dataMeasurements,
}) => {
  const { t } = useTranslation();

  const rows = React.useMemo(() => {
    let stepsDisponibility = dataDisponibility.Objetivo?.Paso ?? {};
    let stepsResponse = dataResponse.Objetivo?.Paso ?? {};
    let measures = dataMeasurements.mediciones;
    let arrayRows = [];
    var stepCount = 0;
    Object.keys(measures).forEach((key0) => {
      stepCount = measures[key0].cantidad_pasos;
      Object.keys(stepsDisponibility).forEach((key1) => {
        let rows = {};
        rows['monitor'] = measures[key0].nombre;
        if (typeof stepCount === 'undefined') {
          const totalUnd = measures[key0].mediciones;
          rows['total'] = totalUnd;
        } else {
          const total = measures[key0].mediciones / stepCount;
          rows['total'] = total;
        }
        rows['paso'] = stepsDisponibility[key1].paso_nombre;

        Object.keys(stepsDisponibility[key1].estado).forEach((key2) => {
          let noMonCum = 0;
          let downCum = 0;
          let upCum = 0;

          if (
            stepsDisponibility[key1].estado[key2].nodo_id ==
            measures[key0].nodo_id
          ) {
            Object.keys(stepsDisponibility[key1].estado[key2].estado).map(
              (key3) => {
                if (
                  stepsDisponibility[key1].estado[key2].estado[key3].nombre ==
                  'uptime'
                ) {
                  upCum =
                    upCum +
                    stepsDisponibility[key1].estado[key2].estado[key3]
                      .porcentaje;
                }
                if (
                  stepsDisponibility[key1].estado[key2].estado[key3].nombre ==
                  'downtime'
                ) {
                  downCum =
                    downCum +
                    stepsDisponibility[key1].estado[key2].estado[key3]
                      .porcentaje;
                }
                if (
                  stepsDisponibility[key1].estado[key2].estado[key3].nombre ==
                  'sin información'
                ) {
                  noMonCum =
                    noMonCum +
                    stepsDisponibility[key1].estado[key2].estado[key3]
                      .porcentaje;
                }
                if (
                  stepsDisponibility[key1].estado[key2].estado[key3].nombre ==
                  'no monitoreo'
                ) {
                  noMonCum =
                    noMonCum +
                    stepsDisponibility[key1].estado[key2].estado[key3]
                      .porcentaje;
                }
              }
            );

            if (upCum === 0) {
              rows['uptime'] = upCum;
            } else {
              rows['uptime'] =
                upCum > 100 || upCum === 100
                  ? upCum.toFixed(2)
                  : upCum.toFixed(3);
            }

            if (downCum === 0) {
              rows['downtime'] = downCum;
            } else {
              rows['downtime'] =
                downCum > 100 || downCum === 100
                  ? downCum.toFixed(2)
                  : downCum.toFixed(3);
            }

            if (noMonCum === 0) {
              rows['nomon'] = noMonCum;
            } else {
              rows['nomon'] =
                noMonCum > 100 || noMonCum === 100
                  ? noMonCum.toFixed(2)
                  : noMonCum.toFixed(3);
            }
          }
        });
        Object.keys(stepsResponse).map((key) => {
          if (stepsResponse[key].paso_id == stepsDisponibility[key1].paso_id) {
            Object.keys(stepsResponse[key].nodos).map((key2) => {
              if (
                stepsResponse[key].nodos[key2].nodo_id == measures[key0].nodo_id
              ) {
                rows['minimo'] =
                  stepsResponse[key].nodos[key2].rendimiento.tiempo_minimo;
                rows['maximo'] =
                  stepsResponse[key].nodos[key2].rendimiento.tiempo_maximo;
                rows['promedio'] =
                  stepsResponse[key].nodos[key2].rendimiento.tiempo_promedio;
              }
            });
          }
        });
        if (rows['minimo'] == null) {
          rows['minimo'] = 's/i';
        }
        if (rows['maximo'] == null) {
          rows['maximo'] = 's/i';
        }
        if (rows['promedio'] == null) {
          rows['promedio'] = 's/i';
        }
        if (rows['uptime'] == null) {
          rows['uptime'] = 's/i';
        }
        if (rows['downtime'] == null) {
          rows['downtime'] = 's/i';
        }
        if (rows['nomon'] == null) {
          rows['nomon'] = 's/i';
        }
        if (rows['total'] == null) {
          rows['total'] = 's/i';
        }
        arrayRows.push(rows);
      });
    });
    return arrayRows;
  });

  return (
    <div style={{ maxWidth: '100%' }}>
      <MaterialTable
        style={{ boxShadow: 'none' }}
        icons={tableIcons}
        columns={[
          {
            title: t(
              'measurements.consolidating-measurements.table.header.monitor'
            ),
            field: 'monitor',
            defaultGroupOrder: 0,
          },
          {
            title: t(
              'measurements.consolidating-measurements.table.header.step'
            ),
            field: 'paso',
          },
          {
            title: t(
              'measurements.consolidating-measurements.table.header.min'
            ),
            field: 'minimo' /*, type: "numeric"*/,
          },
          {
            title: t(
              'measurements.consolidating-measurements.table.header.max'
            ),
            field: 'maximo' /*, type: "numeric"*/,
          },
          {
            title: t(
              'measurements.consolidating-measurements.table.header.average'
            ),
            field: 'promedio' /*, type: "numeric"*/,
          },
          {
            title: t(
              'measurements.consolidating-measurements.table.header.uptime'
            ),
            field: 'uptime' /*, type: "numeric"*/,
          },
          {
            title: t(
              'measurements.consolidating-measurements.table.header.downtime'
            ),
            field: 'downtime' /*, type: "numeric"*/,
          },
          {
            title: t(
              'measurements.consolidating-measurements.table.header.no-monitoring'
            ),
            field: 'nomon' /*, type: "numeric"*/,
          },
          {
            title: t(
              'measurements.consolidating-measurements.table.header.total-monitoring'
            ),
            field: 'total' /*, type: "numeric"*/,
          },
        ]}
        data={rows}
        title=" "
        localization={t(
          'measurements.consolidating-measurements.table.localization',
          { returnObjects: true }
        )}
        options={{
          grouping: true,
        }}
      />
    </div>
  );
};

export default ConsolidatedMeasurements;
